import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AdminSideMenu } from "../admin/AdminMenu";
import API_URL from "../../api/API";
import { useAdminAuthContext } from "../admin/useAdminAuthContext";
//import { AdminEligibilityBuilderAdult } from "./AdminEligibilityBuilderAdult";
//import { AdminEligibilityBuilderMinor } from "./AdminEligibilityBuilderMinor";
import { AdminAdultFullWaiver } from "./AdminAdultFullWaiver";
import { AdminAdultQuickWaiver } from "./AdminAdultQuickWaiver";
import { AdminMinorFullWaiver } from "./AdminMinorFullWaiver";
import { AdminMinorQuickWaiver } from "./AdminMinorQuickWaiver";
//import { AdminEligibilityBuilderAdultQuick } from "./AdminEligibilityBuilderAdultQuick";
//import { AdminEligibilityBuilderMinorQuick } from "./AdminEligibilityBuilderMinorQuick";
import { AdminEligibilityBuilderAll } from "./AdminEligibilityBuilderAll";


export const AdminWaiverConfigure = () => {
  const { serviceid } = useParams(); // serviceId from route
  const navigate = useNavigate();
  const { admin } = useAdminAuthContext();

  const [service, setService] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeTab, setActiveTab] = useState("eligibility");

  const tabs = [
    { key: "eligibility", label: "Eligibility Questions For All Waivers" },
    /*{ key: "adultEligibility", label: "Adult Eligibility" },
    { key: "minorEligibility", label: "Minor Eligibility" }, // ✅ new tab
    { key: "adultquickEligibility", label: "Aduit Quick Eligibility" }, // ✅ new tab'
    { key: "minorquickEligibility", label: "Minor Quick Eligibility" }, // ✅ new tab
    */{ key: "adultFull", label: "Adult Full Waiver" },
    { key: "adultQuick", label: "Adult Quick Waiver" },
    { key: "minorFull", label: "Minor Full Waiver" },
    { key: "minorQuick", label: "Minor Quick Waiver" },
  ];

  useEffect(() => {
    const fetchService = async () => {
      try {
        setIsLoading(true);
        setError("");
        const response = await fetch(`${API_URL.ADMIN_GET_SERVICE}${serviceid}`, {
          headers: { Authorization: `Bearer ${admin.token}`,
          "x-session-id": admin.sessionId,             
          "x-frontend-url": window.location.pathname, },
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || "Failed to fetch service");

        setService(data.service); // assuming API returns { service: {...} }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchService();
  }, [serviceid, admin.token]);

  return (
    <div className="flex h-screen">
      <AdminSideMenu />

      <div className="flex-1 p-6 bg-gray-100 pt-16 flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">Configure Waiver</h1>
            {isLoading ? (
              <p className="text-gray-600">Loading service...</p>
            ) : error ? (
              <p className="text-red-600">{error}</p>
            ) : service ? (
              <p className="text-gray-600">
                <span className="font-semibold">{service.businessType?.name}</span> →{" "}
                <span className="font-semibold">{service.name}</span>
              </p>
            ) : (
              <p className="text-gray-600">Service not found</p>
            )}
          </div>

          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
          >
            Go Back
          </button>
        </div>

        {/* Tabs */}
        <div className="mb-4 border-b border-gray-300 flex">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-2 -mb-px text-sm font-medium border-b-2 transition-colors ${
                activeTab === tab.key
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-300"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

     {/* Tab Content */}
<div className="flex-1 border border-dashed border-gray-400 rounded-lg bg-white p-4 overflow-auto">
  
  {activeTab === "eligibility" && service && (
    <AdminEligibilityBuilderAll service={service} />
  )}

  {/* {activeTab === "adultEligibility" && service && (
    <AdminEligibilityBuilderAdult service={service} />
  )}

  {activeTab === "minorEligibility" && service && (
            <div className="text-sm text-gray-600">
              {/* Replace with Minor Eligibility Builder when ready * /}
            <AdminEligibilityBuilderMinor service={service} />
            </div>
  )}

  {activeTab === "adultquickEligibility" && (
    <div className="text-sm text-gray-600">  <AdminEligibilityBuilderAdultQuick service={service} /></div>
  )}
    {activeTab === "minorquickEligibility" && (
    <div className="text-sm text-gray-600">  <AdminEligibilityBuilderMinorQuick service={service} /></div>
  )} */ }


  {activeTab === "adultFull" && (
    <div className="text-sm text-gray-600">  <AdminAdultFullWaiver service={service} /></div>
  )}
  {activeTab === "adultQuick" && (
    <div className="text-sm text-gray-600">  <AdminAdultQuickWaiver service={service} /></div>
  )}
  {activeTab === "minorFull" && (
     <div className="text-sm text-gray-600">  <AdminMinorFullWaiver service={service} /></div>
  )}
  {activeTab === "minorQuick" && (
    <div className="text-sm text-gray-600">  <AdminMinorQuickWaiver service={service} /></div>
  )}
 
</div>
      </div>
    </div>
  );
};
